import { COLORS } from "../../core/styles/COLORS";

export const loginComponentStyles ={
    width:"100vw", 
    height:"100vh", 
    display:"flex", 
    flexDirection:"column", 
    alignItems:"center", 
    justifyContent:"center", 
    backgroundColor:COLORS.DarkBlue3,
    gap:2,
    position:'relative'
}